export const config = {
    SPACE_FREE : ['zh-cn', 'zh-hk', 'zh-tw', 'ja', 'th'],
    ARAB : ['ar']
}